import {
  IonCol,
  IonContent,
  IonItem,
  IonLoading,
  IonRow,
  IonToast,
} from '@ionic/react';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { EXCEPTIONS } from '../../constants';
import {
  DeviceContext,
  DeviceContextModel,
  TranslationContext,
  UserContext,
} from '../../contexts';
import { analyticsHelper, authenticationHelper } from '../../helpers';
import { webAnalyticsHelper } from '../../helpers/webAnalytics';
import { Character, Customer } from '../../models';
import { authResource, customerResource, routerResource } from '../../resource';
import { StartChatWithCharacterButton } from '../conversations/StartChatWithCharacterButton';
import { CharacterAvatar } from '../global';
import './characterItem.scss';
interface Props {
  character: Character;
  clamped?: boolean;
}

export const CharacterItem: React.FC<Props> = ({ clamped, character }) => {
  const { translate } = useContext(TranslationContext);
  const [displayError, setDisplayError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const device = useContext(DeviceContext) as DeviceContextModel;

  const { user, isCustomer } = useContext(UserContext);
  const customerUser = user as Customer;
  const [minutesToUse, setMinutesToUse] = useState<number>(0);
  const [rechargeLink, setRechargeLink] = useState<string>('');
  const { shortCode, name } = character;

  const location = useLocation();

  // Map character codes to their T&C URLs
  const termsLinksMap: { [key: string]: string } = {
    blaen: 'https://www.blancheofsaintandre.com/terms-conditions',
    agaen: 'https://www.agatha-skyangel.com/terms-conditions',
  };

  const termsLink =
    termsLinksMap[shortCode] ||
    'https://www.blancheofsaintandre.com/terms-conditions';

  // console.log(authResource);

  const fetchMinutes = async () => {
    if (isCustomer && customerUser) {
      const refreshedCustomer = await customerResource.find(
        customerUser['@id'],
        { characterShortCode: shortCode },
      );
      if (refreshedCustomer) {
        if (refreshedCustomer.minutesToUse !== undefined) {
          setMinutesToUse(refreshedCustomer.minutesToUse);
        }
        const settings = (refreshedCustomer.characterSettings ?? []).find(
          s => s.character.shortCode === shortCode,
        );
        setRechargeLink(settings?.rechargeLink ?? '');
      }
    }
  };

  useEffect(() => {
    fetchMinutes();
  }, [customerUser, location]);

  return (
    <Fragment>
      <h1>
        {translate('character.communicationPackageActive') ||
          'Great news! Your communication package is active.'}
      </h1>
      <h2>
        {translate('character.communicationPackage') ||
          'Our Personal Spiritual Conversation is about to begin.'}
      </h2>
      <div className="avatar-message">
        <IonCol style={{ flex: '0 0 70px', width: '70px' }}>
          <CharacterAvatar user={character as Character} />
        </IonCol>
        <div className="bubble">{character.summary}</div>
      </div>
      <StartChatWithCharacterButton
        text={translate('expert.startChat')}
        shortCode={shortCode}
      />
      <p className="timer">
        {translate('character.minutesLeft', {
          minutes: minutesToUse,
          name:
            character.name.charAt(0).toUpperCase() + character.name.slice(1),
        }) ||
          `You still have ${minutesToUse} minutes left to chat with ${
            character.name.charAt(0).toUpperCase() + character.name.slice(1)
          }`}
      </p>
      <div className="actions">
        <a href={rechargeLink} className="upgrade-link">
          <span className="upgrade" />
          {translate('character.upgradePackage') || 'Upgrade Package'}
        </a>
        <a
          href={termsLink}
          className="terms-link"
          target="_blank"
          rel="noreferrer"
        >
          <span className="terms" />
          {translate('character.terms') || 'Terms & Conditions'}
        </a>
      </div>
    </Fragment>
  );
};
